module.exports = __webpack_public_path__ + "img/69.58db8d43.webp";